import React from 'react';
import LocationTemplate from './LocationTemplate';

const PantegoPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Pantego"
      stateName="North Carolina"
      countyName="Beaufort"
      zipCodes={["27860"]}
      latitude={35.5954}
      longitude={-76.6585}
      population={179}
      historicalFact="Incorporated in 1899, name derived from Native American word meaning 'land of bread.'"
      nearbyTowns={[
        "Washington, NC",
        "Belhaven, NC",
        "Plymouth, NC",
        "Columbia, NC",
        "Creswell, NC",
        "Williamston, NC",
        "Jamesville, NC",
        "New Bern, NC"
      ]}
    />
  );
};

export default PantegoPage;